var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isFilterExclusion
    ? _c("filter-exclusion-composable-checkpoint", {
        directives: [
          {
            name: "tooltipped",
            rawName: "v-tooltipped:[tooltip]",
            arg: _vm.tooltip
          }
        ],
        attrs: { "checkpoint-name": _vm.checkpointName }
      })
    : _c("normal-composable-checkpoint", {
        directives: [
          {
            name: "tooltipped",
            rawName: "v-tooltipped:[tooltip]",
            arg: _vm.tooltip
          }
        ],
        attrs: { "checkpoint-name": _vm.checkpointName }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }